import { render } from "./SkinAnalysisView.vue?vue&type=template&id=a634922e"
import script from "./SkinAnalysisView.vue?vue&type=script&lang=js"
export * from "./SkinAnalysisView.vue?vue&type=script&lang=js"

import "./SkinAnalysisView.vue?vue&type=style&index=0&id=a634922e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__